import { getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "../../../../utils/url/urlResolver";
import { ApiCallPriority, apiPOST } from "~/app/api/apiCallsService";
import { transformUpdateApiItem, type UpdatePackageEntryItem } from "~/features/cart/cart/api/UpdatePackageEntry";
import { registerCallProcessor, scheduleCall } from "~/features/cart/cart/api/CartService";
import { naiveTrackCartContents } from "~/app/analytics/ga/abandonment";
import { getCurrentBrowserTimezone } from "~/common/utils/dateUtils";
import { isBEPriceCalculationEnabled } from "~/utils/features";
import { DEPRECATED_ATTRIBUTES_TO_REMOVE } from "./AddToCart";

export function sendDelete(item: UpdatePackageEntryItem) {
  return sendBulkDelete([item]);
}

const bulkDeleteApiUrl = resolveApiUrl("/cart/delete/bulk");
export function sendBulkDelete(items: UpdatePackageEntryItem[]) {
  return scheduleCall("delete", { items });
}

registerCallProcessor({
  type: "delete",
  canBeExecuted: (ongoingCalls) => {
    const areCallsOngoing = ongoingCalls.length > 0;
    return !areCallsOngoing;
  },
  execute: async ({ items }: { items: UpdatePackageEntryItem[] }) => {
    const body = {
      items: items.map((item) => transformUpdateApiItem(item)),
      userTimeZone: getCurrentBrowserTimezone(),
    };

    if (isBEPriceCalculationEnabled()) {
      DEPRECATED_ATTRIBUTES_TO_REMOVE.forEach((attr) => {
        body.items.forEach((item) => {
          // @ts-expect-error - This code will be removed in two releases
          delete item[attr];
          item.optionalParts?.forEach((part) => {
            // @ts-expect-error - This code will be removed in two releases
            delete part[attr];
          });
        });
      });
    }

    const result = await apiPOST(
      bulkDeleteApiUrl,
      {
        body: JSON.stringify(body),
        cache: "no-cache",
        headers: {
          dataType: "json",
          "content-type": "application/json",
          CSRFToken: getCsrfValue(),
        },
        redirect: "follow",
      },
      { priority: ApiCallPriority.HIGH, skipParallelLimit: true },
    );
    window.SCHA.updateMinicart?.();
    naiveTrackCartContents();
    return result;
  },
});
